import { type ReactNode, createContext } from 'react';

import { type ResourceLinkAttributes } from '../../extensions';

export const ResourceNameLinkDefaultsContext =
  createContext<ResourceLinkAttributes>({});

export const ResourceNameLinkDefaults = ({
  children,
  ...attributes
}: ResourceLinkAttributes & { children: ReactNode }): JSX.Element => (
  <ResourceNameLinkDefaultsContext.Provider value={attributes}>
    {children}
  </ResourceNameLinkDefaultsContext.Provider>
);
